import server from '../../public/server/server'

const userApi = {
    //-----------------------用户------------------------------------------------
    // allUserAll:server.requestPath +  '/user/listPage', // 全部用户列表
    allUserAll: server.requestPath + '/user/pcListPage', // 全部用户列表
    saveAddUser: server.requestPath + '/user/save', // 新增编辑用户
    delUser: server.requestPath + '/user/del', // 删除用户
    viewUser: server.requestPath + '/user/get', // 查看
    disableOrOpen: server.requestPath + '/user/disableOrOpen', // 禁用
    importData: server.requestPath + '/user/importData', // 用户导入
    templateDown: server.requestPath + '/user/templateDown', // 模板下载
    claerRole: server.requestPath + '/user/auth/claerRole',//取消授权


    //----------------------用户绑定相关------------------------------------------
    bilingRoleView: server.requestPath + '/user/auth/bilingRoleView', // 绑定角色详情
    bilingRole: server.requestPath + '/user/auth/bilingRole', // 绑定角色/集合绑定等
    areaApply: server.requestPath + '/user/auth/areaApply', // 区域授权----区域授权申请
    areaApplyList: server.requestPath + '/user/auth/areaApplyList', // 区域授权----区域授权申请列表
    areaCheck: server.requestPath + '/user/auth/areaCheck', //区域授权----区域授权审核,解绑
    authAreaByUserIdApply: server.requestPath + '/user/auth/authAreaByUserIdApply', //区域认证审核----区域授权申请列表
    bilingCamer: server.requestPath + '/user/auth/bilingCamer',//摄像机-用户绑定(只有一个)
    bilingCamerTag: server.requestPath + '/user/auth/bilingCamerTag',//摄像机-标签-用户绑定
    bilingCamerView: server.requestPath + '/user/auth/bilingCamerView',//摄像机-用户绑定(只有一个)详情
    unhideCamer: server.requestPath + '/user/auth/unhideCamer', //摄像机-用户解绑(只有一个）
    bilingSTB: server.requestPath + '/user/auth/bilingSTB', // 机顶盒-绑定/编辑
    camerTagList: server.requestPath + '/user/auth/camerTagList', // 摄像机-标签-用户列表
    delSTB: server.requestPath + '/user/auth/delSTB', // 机顶盒-用户删除
    listSTB: server.requestPath + '/user/auth/listSTB', // 机顶盒-用户列表
    unhideCamerTag: server.requestPath + '/user/auth/unhideCamerTag', //摄像机-标签-用户解绑
    upAlarmTypeOrSms: server.requestPath + '/upAlarmTypeOrSms',//摄像机——用户接警类型和是否发送短信
    findAlarmTypeOrsMS: server.requestPath + '/findAlarmTypeOrsMS',//摄像机——获取——用户接警类型和是否发送短信

    areaApplyDel: server.requestPath + '/user/auth/del', //区域授权---删除用户区域授权

    cloudController: server.requestPath + '/cloudController',//摄像头控制


    // 付费统计列表
    cameraPlaybackList: server.requestPath + '/cameraPlayback/list',
    getUserPlayList: server.requestPath + '/cameraPlayback/getUserPlayList',

    getVisionUserList: server.requestPath + '/user/pcListPage',//可视对讲用户列表
}
export {
    userApi
}
